import React, { FunctionComponent, PropsWithChildren } from 'react'
import Box from '@material-ui/core/Box';
import Modal from '@material-ui/core/Modal';
import Slider from 'react-slick'

//
// A modal that allows the user to make a choice when there are several options.
// e.g. Share -> how would you like to share...
//
const ChoiceModal: FunctionComponent<any> = (props: PropsWithChildren<any>) => {

    const { message, isOpen, onClose } = props

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 300,
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        p: 0,
    };

    return <>
        <Modal
            open={isOpen}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            role="dialog"
        >
            <Box sx={style} className='sharePopup watchPopup'>
                <div className="modal-header">
                    <div className="modal-title h4">{message}</div>
                    <div>
                        <button name="close" className="close"
                            onClick={onClose}>
                            <span aria-hidden="true">×</span>
                            <span className="sr-only">Close</span>
                        </button>
                    </div>
                </div>
                <div className='modal-content'>
                    <Slider
                        className='slider_shareIcons'
                        centerPadding='60px'
                        slidesToShow={2}
                        swipeToSlide
                        responsive={[
                            {
                                breakpoint: 767,
                                settings: {
                                    variableWidth: true,
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            }
                        ]}>
                        {props.children}
                    </Slider>
                </div>
            </Box>
        </Modal>
    </>

}

export default ChoiceModal
